import React from 'react';
import CModalRFF from '../../../Assets/Components/CModalRFF';
import CCard from '../../../Assets/Components/CCard';
import { Button, Col, Image, Row } from 'antd';
import { IResultLeadsListDAO } from '../DAO/leads.dao';
import moment from 'moment';
import CIcon from '../../../Assets/Components/CIcon';
import VeryEnthusias from '../../../Assets/Images/sangat-antusias.png';
import Enthusias from '../../../Assets/Images/Antusias.png';
import Normal from '../../../Assets/Images/biasa-saja.png';
import NotEnthusias from '../../../Assets/Images/tidak-tertarik.png';
import NotVeryEnthusias from '../../../Assets/Images/sangat-tidak-tertarik.png';
import HasPermission from '../../../App/HasPermission';

interface IProps {
  data: IResultLeadsListDAO;
  imageList: any;
  handleCancel: () => void;
  handleDelete: () => void;
  isLoading: boolean;
}

export default function ModalLeadComponent(props: IProps) {
  const { data, isLoading, handleCancel, handleDelete, imageList } = props;
  const canDelete = HasPermission('d', '/leads/delete');

  const headerComponent = () => {
    return <h3 className="headerTitle capital">Lead Profile</h3>;
  };

  const renderAntusiasmeBtn = (v: number) => {
    let rendered: any;
    switch (v) {
      case 1:
        rendered = {
          alt: 'NotVeryEnthusias',
          src: NotVeryEnthusias,
          label: 'Sangat tidak tertarik',
        };
        break;
      case 2:
        rendered = {
          alt: 'NotEnthusias',
          src: NotEnthusias,
          label: 'Tidak tertarik',
        };
        break;
      case 3:
        rendered = {
          alt: 'Normal',
          src: Normal,
          label: 'Biasa saja',
        };
        break;
      case 4:
        rendered = {
          alt: 'Enthusias',
          src: Enthusias,
          label: 'Antusias',
        };
        break;
      case 5:
        rendered = {
          alt: 'VeryEnthusias',
          src: VeryEnthusias,
          label: 'Sangat antusias',
        };
        break;
      default:
        rendered = {
          label: '-',
        };
        break;
    }
    return (
      <span>
        {rendered.label}
        {rendered.src && (
          <>
            (
            <img src={rendered.src} alt={rendered.alt} className="width24" />)
          </>
        )}
      </span>
    );
  };

  const renderAge = (age: number) => {
    let rendered = '';
    switch (true) {
      case age <= 20:
        rendered = '<20';
        break;
      case age > 20 && age <= 40:
        rendered = '20-40';
        break;
      case age > 40 && age <= 50:
        rendered = '40-50';
        break;
      case age > 50:
        rendered = '>50';
        break;
      default:
        break;
    }
    return rendered;
  };

  const contentComponent = () => {
    return (
      <div className="contentLead">
        <div className="flex-grow-2">
          <CCard
            cardClassName="cardLicense"
            cardTitle="Upload KTP"
            cardContent={
              <Image src={imageList?.NationalId} width={200} height={200} />
            }
          />
          <CCard
            cardClassName="cardLicense"
            cardTitle="Foto Selfie"
            cardContent={
              <Image src={imageList?.PersonalPhoto} width={200} height={200} />
            }
          />
        </div>
        <div className="flex-grow-3">
          <CCard
            cardClassName="cardLicense"
            cardTitle="Data Pribadi"
            cardContent={
              <Row gutter={12} className="contentLicenseDetailCandidate">
                <Col span={24}>
                  <Row className={'detailCandidateLicense'}>
                    <Col span={12}>Nama Calon Agen (Sesuai KTP)</Col>
                    <Col span={1}>:</Col>
                    <Col span={11}>{data.name}</Col>
                  </Row>
                  <Row className={'detailCandidateLicense'}>
                    <Col span={12}>NIK (Sesuai KTP)</Col>
                    <Col span={1}>:</Col>
                    <Col span={11}>{data.idNumber}</Col>
                  </Row>
                  <Row className={'detailCandidateLicense'}>
                    <Col span={12}>Kota</Col>
                    <Col span={1}>:</Col>
                    <Col span={11}>{data.city}</Col>
                  </Row>
                  <Row className={'detailCandidateLicense'}>
                    <Col span={12}>Tanggal Lahir</Col>
                    <Col span={1}>:</Col>
                    <Col span={11}>
                      {moment(data.dateOfBirth).format('DD-MMM-YYYY')}
                    </Col>
                  </Row>
                  <Row className={'detailCandidateLicense'}>
                    <Col span={12}>Kisaran Usia</Col>
                    <Col span={1}>:</Col>
                    <Col span={11}>{renderAge(data.age)}</Col>
                  </Row>
                  <Row className={'detailCandidateLicense'}>
                    <Col span={12}>Jenis Kelamin</Col>
                    <Col span={1}>:</Col>
                    <Col span={11}>
                      {data.gender === 'M' ? 'Pria' : 'Wanita'}
                    </Col>
                  </Row>
                  <Row className={'detailCandidateLicense'}>
                    <Col span={12}>Antusiasme</Col>
                    <Col span={1}>:</Col>
                    <Col span={11}>{renderAntusiasmeBtn(data.enthusiasm)}</Col>
                  </Row>
                </Col>
              </Row>
            }
          />
          <CCard
            cardClassName="cardLicense"
            cardTitle="Kontak"
            cardContent={
              <Row gutter={12} className="contentLicenseDetailCandidate">
                <Col span={24}>
                  <Row className={'detailCandidateLicense'}>
                    <Col span={12}>Email</Col>
                    <Col span={1}>:</Col>
                    <Col span={11}>{data.leadContacts[1].contact}</Col>
                  </Row>
                  <Row className={'detailCandidateLicense'}>
                    <Col span={12}>Telepon HP</Col>
                    <Col span={1}>:</Col>
                    <Col span={11}>{data.leadContacts[0].contact}</Col>
                  </Row>
                </Col>
              </Row>
            }
          />
          {canDelete && (
            <Button
              className="rounded-10"
              type="primary"
              danger
              block
              icon={<CIcon type="DeleteOutlined" />}
              onClick={handleDelete}
            >
              Delete Lead
            </Button>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <CModalRFF
        contentClassName="contentLicense"
        contentComponent={contentComponent()}
        footerComponent={null}
        handleCancel={handleCancel}
        handleSubmit={() => {}}
        handleValidation={() => {}}
        headerComponent={headerComponent()}
        isLoading={isLoading}
        modalIsShow
        initialValues={null}
        // modalstyles={defaultModalstyles}
      />
    </>
  );
}
